import React, {Component} from 'react';
import '../App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField'
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import SearchIcon from "@material-ui/icons/Search"
import Button from "@material-ui/core/Button";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ReactGA from "react-ga";
import {connect} from 'react-redux';
import {getPrivilegesWithRegions, givePrivileges} from '../actions/privilegeActions'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from 'lodash';
import {red} from '@material-ui/core/colors';
import {withSnackbar} from 'notistack';
import {bffUrl} from '../config.js'
import ContextService from "../Services/ContextService";
import ThumbnailUploader from "../Moments/ThumbnailUploader";
import ExcelUploader from "./ExcelUploader";
import GetAppIcon from "@material-ui/icons/GetApp"
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EmojiEventIcon from "@material-ui/icons/EmojiEvents";
import {LinearProgress} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import {contextServiceUrl} from "../config";
import {urlConfig} from "../config";
import showSnackBar from "../Utilities/SnackbarHelper";
import CardMedia from "@material-ui/core/CardMedia";


const styles = theme => ({
    container: {
        position: 'relative',
        minHeight:"80vh"
    },
});


class PlaylistDescriptionContainer extends Component {

    constructor(props) {

        super(props);

        this.state = {
            contextLanguages: [],
            files:[],
        }
    }

    componentDidMount(){
        let self = this;

        self.props.getPrivilegesWithRegions();

        ContextService.getContextLanguages().then((response)=>{
            if(response.data && response.data.status === "SUCCESS" && response.data.entity && response.data.entity.length>0){
                let contextLanguages = response.data.entity;
                console.log({contextLanguages});
                self.setState({contextLanguages:contextLanguages});

            }else{
                showSnackBar("Error loading supported lanugages. Please refresh.")
            }
        }).catch((error)=>{
            showSnackBar("Error loading supported lanugages. Please refresh.")
        })
    }




    render() {
        const {classes, theme} = this.props;

        const columns = [
            {
                label: 'Language Name',
                name: "name"
            },
            {
                label: 'Language Code',
                name: "id"
            }
        ];


        const options = {
            filterType: 'textField',
            pagination: true,
            selectableRows: 'none',
            print: false,
            viewColumns: false,
            responsive: 'stacked',
        };

        return (
            <>
                {/* {this.props.privileges && this.props.privileges.regions && this.props.privileges.regions.length > 0 && */}
                <Card className={classes.container}>
                    <CardContent>
                        <Typography variant={"h5"}>Bulk Upload Playlist Descriptions</Typography>
                        <br/>
                        <Grid container justify={"center"} alignItems={"center"}>

                            <Grid item xs={8}>
                                <ExcelUploader label={"Drag & Drop / Browse Excel File here to upload."}
                                               files={this.state.files}/>
                            </Grid>

                        </Grid>

                        <br/>
                        <Grid container justify={"center"} alignItems={"center"}>

                            <Grid item xs={3}>
                                <Button variant={"outlined"}
                                        href={`${urlConfig.contextServiceUrl}bulkUpload/template/download/description`}>
                                    <GetAppIcon/> Download Sample Excel Sheet</Button>
                            </Grid>

                        </Grid>
                        <br/>
                        <Grid container justify={"center"} alignItems={"center"}>

                            <Grid item xs={8}>
                                <MUIDataTable
                                    title={"List of supported lanugages with codes"}
                                    data={this.state.contextLanguages}
                                    columns={columns}
                                    options={options}
                                />
                            </Grid>


                        </Grid>
                    </CardContent>

                </Card>
                {/* } */}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privileges: state.privilege.privileges
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrivilegesWithRegions: () => dispatch(getPrivilegesWithRegions())
    }
};

PlaylistDescriptionContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, {withTheme: true})(withSnackbar(PlaylistDescriptionContainer)));
